import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useEmpresaService } from "@services/EmpresaService";
import React from "react";

export enum EnumEmpresa {
    None = "0",
    Max = 1,
    MgSetel = 2,
    Asx = 3,
    Astel = 4,
}
export interface IEmpresa {
    empresaId: EnumEmpresa,
    nome: string,
    razaoSocial: string,
    abbr: string,
    email: string,
    empresaStatusId: number,
}

export type IComboEmpresa = ISpecializedCombo<IEmpresa>;

export function useEmpresaCombo (initialValue?: EnumEmpresa) : IComboEmpresa {
    const combo = useCombo<IEmpresa>({
        value: initialValue
    });

    const empresaService = useEmpresaService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((empresa, index) => {
            return <MenuItem key={index} value={empresa.empresaId}>{ empresa.nome }</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(empresaService.listarAtivas)
    }, [combo, empresaService.listarAtivas]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}